module.exports = __webpack_public_path__ + "static/img/porque-usar-kallpa.9eefbe5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/porque-usar-kallpa.png
// module id = A6ld
// module chunks = 1